import colors from '../../_shared/colors';

export default {
  container: `
    background-color: ${colors.white};
    border-right: 2px solid ${colors.inputBorder};
  `,
  liContainer: `
    display: flex;
    align-items: flex-start;
  `,
  // `liContainer` overrides antd's `display: block` on .ant-menu-item, which
  // turns a bare `{route.title}` text node into an ANONYMOUS flex item —
  // antd's own `text-overflow: ellipsis` cannot apply to one, so an over-long
  // label was silently hard-clipped by the item's `overflow: hidden` with no
  // "…" and no cue that anything was missing (card #254 round 3). Wrapping the
  // title in a real element and re-declaring the truncation rules here — plus
  // `min-width: 0`, without which a flex item refuses to shrink below its
  // min-content width — makes any future long label degrade to an ellipsis.
  title: `
    min-width: 0;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
  `,
  faContainer: `
    min-width: 14px;
    margin-right: 10px;
    font-size: 14px;

    display: inline-block;
    color: inherit;
    font-style: normal;
    line-height: 0;
    text-align: center;
    text-transform: none;
    text-rendering: optimizeLegibility;
    -webkit-font-smoothing: antialiased;
  `,
};
